"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cleanup = void 0;
var react_1 = __importDefault(require("react"));
var inversify_react_1 = require("inversify-react");
var SectionHeading_1 = require("../SectionHeading");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var LastEditedCleanup_1 = require("Reports/ReportsCleanup/LastEditedCleanup");
var Types_1 = require("Reports/Types");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var Types_2 = require("../Types");
var UseAnalyticsAccountSettings_1 = require("../UseAnalyticsAccountSettings");
var c = (0, BemBuilder_1.default)("analytics-and-reports-settings");
function Cleanup() {
    var _a = (0, UseAnalyticsAccountSettings_1.useAnalyticsAccountSettings)(), data = _a.data, updateCleanup = _a.updateCleanup;
    var telemetry = (0, inversify_react_1.useInjection)("telemetry");
    var updater = function (_a) {
        var enabled = _a.enabled, lastEditedDays = _a.lastEditedDays;
        telemetry.trackOnly(Types_1.ReportTelemetryEventName.AnalyticsAndReportingSettingsChanged, {
            last_edited_changed: enabled ? lastEditedDays : undefined,
        }, { blockIntercom: true });
        return updateCleanup({ lastEdited: { enabled: enabled, lastEditedDays: lastEditedDays } });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SectionHeading_1.SectionHeading, { id: Types_2.AnalyticsSettingSectionId.Cleanup, icon: react_1.default.createElement(icons_1.Spark, null), headingText: "Default Clean up", description: react_1.default.createElement(kaleidoscope_1.Text, null, "Manage Clean up default quick filters and values to show in the reports") }),
        data ? (react_1.default.createElement(LastEditedCleanup_1.LastEditedCleanup, { className: c("last-edited-cleanup"), onChange: updater, initialValue: data.defaultCleanup.lastEdited, inSettingsPage: true })) : null));
}
exports.Cleanup = Cleanup;
